import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {brandCategoryStyles} from './index.style'
import LoadingSpinner from '../../../../components/loading-spinner'

function BrandCategory({category}) {
    const {token} = useAccessToken()
    const {response, loading} = useCustomFetch(token, [
        `dynamiccategorylanding-categories:category:${category?.id}`
    ])

    if (loading) {
        return <LoadingSpinner />
    }

    return <Box sx={brandCategoryStyles} dangerouslySetInnerHTML={{__html: response}} />
}

BrandCategory.propTypes = {
    category: PropTypes.object
}

export default BrandCategory
